/**
 *
 * FileDownload
 *
 * Generic "resume a token-gated file download" page. Works for any feature
 * that hands out a media-resource download link (currently: exports), not
 * just this one — it only knows about {id, token}, nothing export-specific.
 * Reaching this page already implies the user is authenticated (it's nested
 * under PrivateRoute), so navigating straight to the backend download route
 * carries the session cookie automatically, including after a login redirect
 * that brought the user back here.
 */

import React, { memo, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams, useSearchParams } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import messages from './messages';

export function FileDownload() {
  const intl = useIntl();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [invalid, setInvalid] = useState(false);

  const downloadUrl = `/traily/api/files/${id}/download?token=${token}`;

  useEffect(() => {
    if (!id || !token) {
      setInvalid(true);
      return;
    }
    window.location.href = downloadUrl;
  }, [id, token, downloadUrl]);

  return (
    <Box sx={{ mt: 4, textAlign: 'center' }}>
      {invalid ? (
        <Typography>{intl.formatMessage(messages.invalidLink)}</Typography>
      ) : (
        <>
          <Typography>{intl.formatMessage(messages.preparing)}</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            <Link href={downloadUrl}>
              {intl.formatMessage(messages.manualLink)}
            </Link>
          </Typography>
        </>
      )}
    </Box>
  );
}

export default memo(FileDownload);
